var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
export var hoverRaise = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  box-shadow: ", ";\n  transition: all .15s;\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: ", ";\n  }\n"], ["\n  cursor: pointer;\n  box-shadow: ", ";\n  transition: all .15s;\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.shadows.low;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.high;
});
var templateObject_1;
